import { render, staticRenderFns } from "./Item-OtherProducts.vue?vue&type=template&id=bcf2ded0&scoped=true&lang=pug"
import script from "./Item-OtherProducts.vue?vue&type=script&lang=js"
export * from "./Item-OtherProducts.vue?vue&type=script&lang=js"
import style0 from "./Item-OtherProducts.vue?vue&type=style&index=0&id=bcf2ded0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf2ded0",
  null
  
)

export default component.exports